export default "https://cdn-static.gokick.com/assets/fd6b0a6afc37e3a7e4b7ae7c7f4dd4a202138084/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";